<script>
    import Drawer, { Content, Header } from '@smui/drawer';
    import List from '@smui/list';
    import { organizationList } from '../../organizations/organizations';
    import { userList } from "../../users/users";
    import PageNumber from './PageNumber.svelte';
    // https://getbootstrap.com/docs/5.0/layout/breakpoints/
    
    const largeScreenBreakpoint = 993;
    let isLargeScreen = window.innerWidth >= largeScreenBreakpoint;
    window.addEventListener('resize', () => {
        isLargeScreen = window.innerWidth >= largeScreenBreakpoint;
    });

    export let currentPage = 1;

    organizationList.resetSelected()
    userList.resetSelected()

</script>

<Drawer variant="static">
    <Header>
        {#if isLargeScreen}
            <img id="image0" class="logo-wide"  src="images/we-id-logo.svg"/>
        {:else}
            <img id="image1" class="logo-small" src="images/we-id-small.png"/>
        {/if}
    </Header>
    <Content>

        <List nonInteractive>
            <PageNumber currentPage={currentPage} pageNumber={1} pageTitle="Aanvrager" navigationLink="#/registration"/>
            <PageNumber currentPage={currentPage} pageNumber={2} pageTitle="Organisaties" navigationLink="#/organizations"/>
            <PageNumber currentPage={currentPage} pageNumber={3} pageTitle="Gebruikers" navigationLink="#/users"/>
            <PageNumber currentPage={currentPage} pageNumber={4} pageTitle="Overzicht" navigationLink="#/summary"/>
            <PageNumber currentPage={currentPage} pageNumber={5} pageTitle="Prijsindicatie" navigationLink="#/quote"/>
            <PageNumber currentPage={currentPage} pageNumber={6} pageTitle="Verzendinstructies" navigationLink="#/download"/>
        </List>
    </Content>
</Drawer>

<style>
    .logo-wide {
        width: 200px;
        height: 82px;
    }

    .logo-small {
        height: 62px;
        width:54px;
    }
</style>
